import { v4 } from 'uuid';
import { GameStatus } from '../base/GameState.js';
export var WinGameCmdTypes;
(function (WinGameCmdTypes) {
    WinGameCmdTypes["Win"] = "WIN";
})(WinGameCmdTypes || (WinGameCmdTypes = {}));
const winGame = (game, cmd) => {
    const gameId = cmd.gameId;
    const winnerUserId = cmd.player.userId;
    if (game.status !== GameStatus.InProgress) {
        throw new Error('Game can only be won if in progress.');
    }
    const gameState = {
        score: game.players.map((player) => ({
            playerId: player.userId,
            score: player.userId === winnerUserId ? 1 : 0,
        })),
    };
    const winEvent = {
        eventId: v4(),
        gameId,
        gameRuleSetName: game.gameRuleSetName,
        eventType: WinGameCmdTypes.Win,
        eventData: {},
    };
    const resultGame = { ...game, gameState, status: GameStatus.Complete };
    const result = {
        game: resultGame,
        events: [winEvent],
    };
    return result;
};
export const winGameHandlers = { winGame };
//# sourceMappingURL=WinThisGame.js.map